
// save the positions for the current trial drags
window.draggableStimsResponses = {};
window.draggableStimsDraggables = [];

function showBackgroundWithStim(trialRow) {
showBackground(trialRow, 'withStim');
}

// trialSection can be withStim, afterStim etc. defaults to withStim
function showBackground(trialRow, trialSection) {
  const chosenTrialSection  = trialSection || 'withStim';
  const backgroundOptions = getBackgroundForTrialRow(trialRow);
  const image = getBackgroundImageForSection(backgroundOptions, chosenTrialSection);
  if (image) {
    const displayScreenEl = document.body;
    displayScreenEl.style.backgroundPosition = "center center";
    displayScreenEl.style.backgroundRepeat = "no-repeat";
    displayScreenEl.style.backgroundImage = "url('" + window.locationStim + image + "?ts=" + window.startPreloadTime + "')";

    //if calibration is present
    if(window.adjuster != 1){
      displayScreenEl.style.backgroundSize = window.listBackgroundSizes[image].width * adjuster + "px";
    }

  }
}

function getBackgroundForTrialRow(trialRow) {
  return window.listBackgroundOptions[trialRow] || {};
}
function getBackgroundImageForSection(backgroundOptions, chosenTrialSection) {
  if (!backgroundOptions[chosenTrialSection] || !backgroundOptions[chosenTrialSection].image) {
    return null;
  }
  return backgroundOptions[chosenTrialSection].image;
}

function enableDraggableStims(trialRow) {
  // we will restrict the drag to displayScreen
  const displayScreenEl = null;

  for(var i = 1; i <= window.listNoStim[trialRow]; i++) {
    const stimElement = window.stimContainers[i];
    makeStimDraggable(stimElement, displayScreenEl);
    stimElement.style.cursor = getCursorForCurrentTrial();
  }

  function makeStimDraggable(stimElement, restrictElement) {
    stimElement.style.borderWidth = '0'; // will be reset 
    const width = stimElement.offsetWidth;
    const height = stimElement.offsetHeight;
    var options = {
      setCursor: true,
      // save the last position and the time when a stimuli was dropped
      onDragEnd: function(stimElement, x, y) { 

        const elementId = stimElement.getAttribute('id');

        var stimPosition = computeRelativeStimPosition(stimElement);

        draggableStimsResponses[elementId] = {
          x: stimPosition.x, 
          y: stimPosition.y,
          width: width,
          height: height,
          timestamp: performance.now(),
        };

        const uniqueDraggedStims = Object.keys(window.draggableStimsResponses).length;
        const countOptions = window.listTrialResponseOptions[window.trialRow].multipleResponses;

        if (countOptions && uniqueDraggedStims >= countOptions.max) {
          saveDragResponse();
          return;
        }

        if($('#saveDragButton').length == 0 && !(countOptions && uniqueDraggedStims < countOptions.min)){
          showDragButton();
        }
      }
    };

    if (restrictElement) {
      options.limit = restrictElement;
    } else {
      computeDefaultDraggableLimits(trialRow, options, width, height);
    }

    console.log('draggable with options', options);
    window.draggableStimsDraggables.push(new Draggable (stimElement, options));
  }

  function computeRelativeStimPosition(stimElement) {
    const stimBoundingRect = stimElement.getBoundingClientRect();
    const displayScreenRect = document.getElementById('displayScreen').getBoundingClientRect();

    var stimCenterPosRelativeToViewport = {
      'x': stimBoundingRect.x + stimBoundingRect.width/2,
      'y': stimBoundingRect.y + stimBoundingRect.height/2
    };

    var displayScreenCenterRelativeToViewport = {
      'x': displayScreenRect.x + displayScreenRect.width/2,
      'y': displayScreenRect.y + displayScreenRect.height/2
    };

    return {
      'x': Math.round(stimCenterPosRelativeToViewport.x - displayScreenCenterRelativeToViewport.x), 
      'y': Math.round(stimCenterPosRelativeToViewport.y - displayScreenCenterRelativeToViewport.y),
    };
  }
}

function computeDisplayScreenSize() {
  const displayScreen = document.getElementById("displayScreen");
  return computeElementSize(displayScreen)
}

function computeElementSize(el) {
  const elRect = el.getBoundingClientRect();
  return {width : elRect.width, height: elRect.height};
}

function computeDefaultDraggableLimits(trialRow, options, stimWidth, stimHeight) {
  const backgroundOptions = getBackgroundForTrialRow(trialRow);
  const image = getBackgroundImageForSection(backgroundOptions, 'withStim');
  
  // we don't have a background so no restrictions
  if (!image || !listBackgroundSizes[image]) {
    return;
  }

  const displayScreenSize = computeDisplayScreenSize();
  const backgroundWidth = listBackgroundSizes[image].width;
  const backgroundHeight = listBackgroundSizes[image].height;
  const horizontalOffset =  (backgroundWidth - displayScreenSize.width) / 2;
  const verticalOffset =  (backgroundHeight- displayScreenSize.height) / 2;

  options.limit = {
    x: [-horizontalOffset, displayScreenSize.width + horizontalOffset - stimWidth],
    y: [-verticalOffset, displayScreenSize.height + verticalOffset - stimHeight],
  };
}

function generateDragResponseAndRTs() {
  const stimResponses = [];
  const RTs = [];
  
  for (var stimId in window.draggableStimsResponses) {
    if (window.draggableStimsResponses.hasOwnProperty(stimId)) {
      const result = window.draggableStimsResponses[stimId];
      const stimIndex = computeIndexFromStimId(stimId);
      stimResponses.push(stimIndex + '_' + result.x + 'x' + result.y);
      const RT = Math.round(result.timestamp - window.timeInMs);
      RTs.push(RT);
    }
  }

  if ( stimResponses.length === 0 ) {
    return null;
  }

  return {
    response: stimResponses,
    RT: RTs,
  };

  function computeIndexFromStimId(stimId) {
    const indexMatches = stimId.match(/\d+$/);
    var stimIndex = 1;
    if (indexMatches) {
        stimIndex = parseInt(indexMatches[0], 10);
    } 
    return stimIndex;
  }
}

function precomputeBackgroundOptions(trial){
    const stimuliRegex = /[\w,\s-]+\.[A-Za-z]{1,4}/;

    var option = {};

    var content = window.columnForTrial('background', trial);
    
    if(content == "na"){
        return option;
    }

    var matches = stimuliRegex.exec(content);
    if(matches && matches[0]){
        var imageName = matches[0].trim()
        option.withStim = {
            image: imageName,
        }
    }
    return option;
}

function showDragButton(){
    const button1 = window.buttonsContainers[1];
    const displayScreenBound = document.getElementById('displayScreen').getBoundingClientRect();
        
    var lowestBound = displayScreenBound.bottom;

    for(var i = 1; i <= window.listNoStim[window.trialRow]; i++){
        const stimElement = window.stimContainers[i];
        const currentLowerBound = stimElement.getBoundingClientRect().bottom;
        lowestBound = currentLowerBound > lowestBound ? currentLowerBound : lowestBound;
    }


    var dragButton = button1.cloneNode(true);
    dragButton.id = 'saveDragButton';
    dragButton.onclick = saveDragResponse;
    dragButton.style.display = "block";
    dragButton.style.visibility = "hidden";
    dragButton.style.top = lowestBound - 25 + "px";
    dragButton.innerHTML = defaultButtonText;

    var showNextBtn = !formInfo.required && !trialHasButtonsActive(window.trialRow);

    // Adds a next button that calls save
    if ( showNextBtn ) {
        $('#displayScreen').append(dragButton);
        dragButton.style.left = (canvasWidth/2 - dragButton.getBoundingClientRect().width/2) + "px";
        dragButton.style.visibility = "";
    }
}

function saveDragResponse(){
    const responseAndRT = generateDragResponseAndRTs();
    window.draggableStimsResponses = {};

    for(var i = 1; i <= window.listNoStim[trialRow]; i++) {
        const stimElement = window.stimContainers[i];
        stimElement.style.borderWidth = '';
        stimElement.style.cursor = '';
        stimElement.style.width = '';
        stimElement.style.height = '';
    }

    window.draggableStimsDraggables.forEach(function(draggable) {
        draggable.destroy();
    });

    if(responseAndRT != null){
        window.RTkeys_trial = responseAndRT.RT.join(';');
        window.clickGeneral( responseAndRT.response.join(';'));
    }
    else{
        window.clickGeneral('');
    }
    $('#saveDragButton').remove();
}

function getBackgroundActualHeight(){

    const img = 'body';

    var imageSrc = $(img).css('backgroundImage')
                   .replace(/url\((['"])?(.*?)\1\)/gi, '$2')
                    .split(',')[0];    
    var image = new Image();
    image.src = imageSrc;
    var bgwidth = image.width,
    bgheight = image.height,    
    bgContainWidth = $(img).width();

    var bgContainHeight = (bgheight*bgContainWidth)/bgwidth;

    return Math.ceil(bgContainHeight) || 0;
}